/** Import hooks */

import { Cleaner } from "../Misc/ObjectCleaner";

const

DEFAULT_PAGE_SIZE = 21,

PAGINATION_KEYS = [ "f", "l", "b", "a", "p", "lp", "loc" ],

normalizePageSize = value => {
    const parsed = parseInt ( value );

    if ( isNaN ( parsed ) || parsed <= 0 || parsed === 12 ) return DEFAULT_PAGE_SIZE;

    return parsed;
},

/** @returns URL parameters */

TyresNavigator = ( params, update ) => { const parameters = new URLSearchParams ( params ),

    /** Register attributes */

    attributes = {

        f       : parseInt      ( parameters.get ( "f" ) ),

        l       : parseInt      ( parameters.get ( "l" ) ),

        b       : parameters.get ( "b" ),

        a       : parameters.get ( "a" ),

        w       : parseInt      ( parameters.get ( "w" ) ),

        h       : parseFloat    ( parameters.get ( "h" ) ),

        d       : parameters.get ( "d" ),

        s       : parameters.get ( "s" ),

        m       : parameters.get ( "m" ),

        sp      : parameters.get ( "sp" ),

        li      : parameters.get ( "li" ),

        ni      : parameters.get ( "ni" ),

        sr      : parameters.get ( "sr" ),

        fe      : parameters.get ( "fe" ),

        wg      : parameters.get ( "wg" ),

        vt      : parameters.get ( "vt" ),

        pr      : parameters.get ( "pr" ),

        sort    : parameters.get ( "sort" ),

        ss      : parameters.get ( "ss" ),

        sset    : parameters.get ( "sset" ),

        ct      : parameters.get ( "ct" ),

        st      : parameters.get ( "st" ),
        
        av      : parameters.get ( "av" ),

        rf      : parameters.get ( "rf" ),

        lp      : parameters.get ( "lp" ),

        p       : parseInt      ( parameters.get ( "p" ) )

    },

    nextAttributes = Cleaner ( { ...attributes, ...update } ),

    shouldResetPage = update && Object.keys ( update ).some ( key => ! PAGINATION_KEYS.includes ( key ) );

    if ( shouldResetPage ) {

        nextAttributes.p  = 1;

        nextAttributes.a  = null;

        nextAttributes.b  = null;

        nextAttributes.lp = null;

    }

    if ( ! nextAttributes.p || nextAttributes.p < 1 ) nextAttributes.p = 1;

    if ( nextAttributes.lp ) {
        nextAttributes.f = null;
        nextAttributes.l = normalizePageSize ( nextAttributes.l );
        nextAttributes.a = null;
        nextAttributes.b = null;
    } else if ( nextAttributes.b ) {
        nextAttributes.l = normalizePageSize ( nextAttributes.l );
        nextAttributes.f = null;
    } else {
        nextAttributes.f = normalizePageSize ( nextAttributes.f );
        nextAttributes.l = null;
    }

    /** Optimize, clean & return attributes */

    return Cleaner ( nextAttributes );

},

/** @returns Query attributes based on URL parameters */

QueryAttributes = ( params ) => { const parameters = new URLSearchParams ( params );

    const before = parameters.get ( "b" ),

    lastPage = parameters.get ( "lp" ),

    first = before || lastPage ? null : normalizePageSize ( parameters.get ( "f" ) ),

    last = before || lastPage ? normalizePageSize ( parameters.get ( "l" ) ) : null;

    /** Optimize, clean & return query attributes */

    return Cleaner ( {

        first                       : first,

        last                        : last,

        before                      : before,

        after                       : parameters.get ( "a" ),

        width                       : parseInt      ( parameters.get ( "w" ) ),

        height                      : parseFloat    ( parameters.get ( "h" ) ),

        diameter                    : parameters.get ( "d" ),

        season                      : parameters.get ( "s" ) ? parameters.get ( "s" ).split ( "," ) : [],

        manufacturer                : parameters.get ( "m" ) ? parameters.get ( "m" ).split ( "," ) : [],

        specifications              : parameters.get ( "sp" ),

        loadIndex                   : parameters.get ( "li" ) ? parameters.get ( "li" ).split ( "," ) : [],

        noiseIndex                  : parameters.get ( "ni" ) ? parameters.get ( "ni" ).split ( "," ) : [],

        speedRating                 : parameters.get ( "sr" ) ? parameters.get ( "sr" ).split ( "," ) : [],

        vehicleType                 : parameters.get ( "vt" ),

        fuelEfficiency              : parameters.get ( "fe" ) ? parameters.get ( "fe" ).split ( "," ) : [],

        wetBreakingEfficiency       : parameters.get ( "wg" ) ? parameters.get ( "wg" ).split ( "," ) : [],

        upperPriceRange             : ( params.get("pr") ) ? parseInt ( params.get("pr").split ( "," )[1] ) : null,
        
        lowerPriceRange             : ( params.get("pr") ) ? parseInt ( params.get("pr").split ( "," )[0] ) : null,

        sortOrder                   : parameters.get ( "sort" ),

        showSingles                 : Boolean ( parameters.get ( "ss" ) ),

        isCTire                     : Boolean ( parameters.get ( "ct" ) ),

        runFlat                     : Boolean ( parameters.get ( "rf" ) ),

        studs                       : parameters.get ( "st" ),
        
        showSet                     : Boolean ( parameters.get ( "sset" ) ),

        isCTire                     : Boolean ( parameters.get ( "ct" ) ),

        availability                : parameters.get ( "av" ) ? parameters.get ( "av" ).split ( "," ) : []

    } );

};

/** Export hooks */
 
export { TyresNavigator, QueryAttributes };